const view = /*html*/`
    <div id="kt_content_container" class="container-xxl lobby-explicit">
        
    
        <div class="d-flex flex-column mb-5 mb-xl-8">
            <!--begin::Order details-->
            <div class="card card-flush w-100" style="background-size: cover; background-repeat: no-repeat; background-image: url('assets/media/logos/lobby_header.png');">
                <div style="background-color: rgba(21,21,21,.925);">
                    <div class="d-flex flex-column align-items-center card-body" style="/*background: linear-gradient(rgba(21,21,21,0),#151515);*/">
                        <div class="d-flex flex-column text-center align-items-center mb-10">
                            <h3 id="lobby-title" class="fw-bolder text-dark fs-2 mb-0"></h3>
                            <div class="d-flex flex-column text-center align-items-center mb-5">
                                <span class="text-gray-700 mb-1"><span id="lobby-serverip"></span> <i class="lobby-server-btn cursor-pointer ms-1 fal fa-copy fs-4 text-gray-700 text-hover-white clip" data-clipboard-text="" data-bs-toggle="popover" data-bs-delay-hide="1000" data-bs-trigger="manual" data-bs-html="true" data-bs-content="<span class='text-success'>Copied!</span>" data-bs-placement="top"></i></span>
                            </div>
                            <span id="lobby-ongoing" class="badge border"></span>
                        </div>
                        <div class="d-flex w-100 justify-content-center gap-10 mb-4">
                            <div class="d-flex w-100 align-items-center">
                                <div class="me-auto">
                                    <h4 class="lobby-team-A-name"></h4>
                                    <!--<h6>Tuscan chino</h6>-->
                                </div>
                                <!--<div class="d-block m-0">
                                    <img class="mw-100px h-auto" id="lobby-logo-teamA" style="vertical-align: middle" src="assets/media/logos/mixedA.png">
                                </div>-->
                                <div class="symbol symbol-75px">
                                    <span class="symbol-label bg-white bg-opacity-5">
                                        <img class="mw-100 h-auto" id="lobby-logo-teamA" style="vertical-align: middle" src="">
                                    </span>
                                </div>
                            </div>                                
                            <div class="d-flex w-125px justify-content-center align-items-center gap-4">
                                <!--<span class="badge badge-light-dark text-uppercase mb-2">
                                    <span class="lobby-vs"></span><span class="text-lowercase">v</span><span class="lobby-vs"></span>
                                </span>
                                <span class="text-gray-800 text-nowrap">Best Out of <span id="lobby-bo">1</span></span>-->
                                <div class="d-flex justify-content-end fs-2tx fw-bolder"><span class="lobby-scorea text-gray-800">0</span></div>
                                <span class="fs-3 text-gray-600 fw-bold">:</span>
                                <div class="d-flex justify-content-start fs-2tx fw-bolder"><span class="lobby-scoreb text-gray-800">0</span></div>
                            </div>
                            <div class="d-flex w-100 align-items-center">
                                <!--<div class="d-block m-0">
                                    
                                </div>-->

                                <div class="symbol symbol-75px">
                                    <span class="symbol-label bg-white bg-opacity-5">
                                        <img class="mw-100 h-auto" id="lobby-logo-teamB" style="vertical-align: middle" src="">
                                    </span>
                                </div>

                                <div class="ms-auto text-end">
                                    <h4 class="lobby-team-B-name"></h4>
                                    <!--<h6>Tuscan chino</h6>-->
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column text-center align-items-center">
                            <span id="lobby-winchance" class="text-gray-700 mb-1">WIN CHANCE <i class="ms-1 fad fa-question-circle fs-4 text-gray-700" data-toggle="tooltip" title="The winrate is based on the individual players recent performance combined against the opponents recent performance. We look at metrics such as rating, KDR, & more."></i></span>
                            <div class="p-1 d-flex flex-row gap-0 rounded bg-light w-200px">
                                <div class="progress h-5px lobby-wcA" data-toggle="tooltip" title="50%" style="width:50%">
                                    <div class="progress-bar bg-info w-100" role="progressbar"></div>
                                </div>
                                <div class="progress h-5px lobby-wcB" data-toggle="tooltip" title="50%" style="width:50%">
                                    <div class="progress-bar bg-success w-100" role="progressbar"></div>
                                </div>
                            </div>                          
                        </div>

                        
                    </div>
                    <div class="card-footer border-0 d-flex justify-content-around align-items-center py-6" style="background-color: #1b1b1b;">
                        
                        <!--begin::Item-->                  
                        <div class="d-flex align-items-center">
                            <!--begin::Symbol-->
                            <div class="symbol symbol-40px me-3">
                                <span class="symbol-label bg-success">                                    
                                    <i class="bi bi-activity text-gray-100 fs-3"></i>
                                </span>
                            </div>
                            <!--end::Symbol--> 
                            
                            <!--begin::Info-->
                            <div class="m-0">                            
                                <span class="fw-semibold text-gray-500 d-block fs-8" data-i18n="play.status">Status</span>
                                <span class="fw-bold text-gray-800 fs-7 lobby-status"></span>
                            </div>
                            <!--end::Info-->
                        </div>                    
                        <!--end::Item-->

                        <!--begin::Item-->                  
                        <div class="d-flex align-items-center">
                            <!--begin::Symbol-->
                            <div class="symbol symbol-40px me-3">
                                <span class="symbol-label bg-success">
                                    <i class="bi bi-geo-alt text-gray-100 fs-3"></i>
                                </span>
                            </div>
                            <!--end::Symbol--> 
                            
                            <!--begin::Info-->
                            <div class="m-0">                            
                                <span class="fw-semibold text-gray-500 d-block fs-8" data-i18n="play.region">Region</span>
                                <span class="fw-bold text-gray-800 fs-7 lobby-region"></span>
                            </div>
                            <!--end::Info-->
                        </div>                    
                        <!--end::Item-->
                    </div>
                </div>                
            </div>            
        </div>

        <div class="d-flex mb-5 mb-xl-8 justify-content-between">
            <div class="card card-flush">
                <div class="d-flex flex-row justify-content-between">
                    <div class="d-flex gap-0">
                        <div class="px-6 py-5 rounded bg-primary rounded-end-0 text-nowrap">
                            <span class="nav-text text-gray-200 fw-bolder fs-6 mb-3 text-uppercase">Pick Up Game</span>
                        </div>
                        <ul class="nav nav-pills nav-pills-custom position-relative mx-0" role="tablist">
                            <!--begin::Item--> 
                            <li class="nav-item mx-0 px-0" role="presentation">
                                <!--begin::Link--> 
                                <span class="cursor-pointer nav-link d-flex justify-content-center w-100 border-0 h-100 py-5 px-10 active" data-bs-toggle="pill" href="#lobby-tab-overview" aria-selected="true" role="tab">                   
                                    <!--begin::Subtitle-->
                                    <span class="nav-text text-gray-800 fw-bold fs-6">Overview</span> 
                                    <!--end::Subtitle-->
                                    
                                    <!--begin::Bullet-->
                                    <span class="bullet-custom position-absolute z-index-2 bottom-0 w-100 h-3px bg-primary rounded rounded-start-0"></span>
                                    <!--end::Bullet-->
                                </span>
                                <!--end::Link-->                
                            </li>
                            <!--end::Item--> 

                            <!--begin::Item--> 
                            <li class="nav-item mx-0 px-0" role="presentation">
                                <!--begin::Link--> 
                                <span class="cursor-pointer nav-link d-flex justify-content-center w-100 border-0 h-100 py-5 px-10 score-pill" data-bs-toggle="pill" href="#lobby-tab-scoreboard" aria-selected="false" role="tab" tabindex="-1">                   
                                    <!--begin::Subtitle-->
                                    <span class="nav-text text-gray-800 fw-bold fs-6">Scoreboard</span> 
                                    <!--end::Subtitle-->
                                    
                                    <!--begin::Bullet-->
                                    <span class="bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded"></span>
                                    <!--end::Bullet-->
                                </span>
                                <!--end::Link-->                
                            </li>
                            <!--end::Item--> 
                            <span class="position-absolute z-index-1 bottom-0 w-100 h-4px bg-light rounded"></span>                               
                        </ul>
                    </div>                    
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-between gap-4 lobby-buttons">
                
            </div>
        </div>
        

        <!--<div class="flex-lg-row row mx-auto justify-content-between flex-wrap mb-5 mb-xl-8">
            <div class="d-flex justify-content-between align-items-stretch flex-wrap p-0">
                <div class="d-block">
                    <label for="" class="form-label text-muted fs-7 mb-1">Share the lobby url and invite friends</label>
                    <div class="input-group input-group-sm justify-content-center w-auto">
                        <span class="input-group-text bg-transparent w-250px text-gray-700"><span id="lobby-share-url" class="text-nowrap text-truncate text-decoration-underline text-hover-white cursor-pointer"></span></span>
                    <button id="lobby-btn-share" type="button" class="btn btn-copy btn-icon btn-outline btn-outline-light btn-sm" data-clipboard-target="#lobby-share-url">
                            
                            <span class="svg-icon svg-icon-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.5" d="M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z" fill="currentColor"></path>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z" fill="currentColor"></path>
                                </svg>
                            </span>
                            
                        </button>
                    </div>
                </div>
                <div class="d-flex align-items-center flex-wrap lobby-buttons">
                    
                </div>
            </div>
        </div>-->
        
        <div class="tab-content">
            <div class="tab-pane fade show active" id="lobby-tab-overview" role="tabpanel">

                <div class="d-flex flex-md-row flex-column gap-2 mb-5 mb-xl-8">            
                    <div class="w-100 teamAlist">            
                        
                    </div>

                    <div class="w-100">
                        <div class="card card-flush">
                            <div class="card-body p-5">
                                <div class="d-flex align-items-center">
                                    <div class="w-100 h-80px lobby-map-bg" style="
                                    background-position: center;
                                    background-size: cover;
                                    background-repeat: no-repeat;
                                    background-color: #484848;
                                    border-radius: 4px;">
                                    </div>
                                    <span class="position-absolute badge text-white text-nowrap fw-normal fs-7 lobby-map-name" style="top: 50%;transform: translate(-50%,-50%);left: 50%;background-color:rgba(21,21,21,0.75)">de_lite</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-100 teamBlist">            
                        
                    </div>
                </div>

            </div>


            <div class="tab-pane fade " id="lobby-tab-scoreboard" role="tabpanel">
                <style>                    
                    .dtfc-right-top-blocker{
                        display:none!important;
                    }
                    table.dataTable tbody tr > .dtfc-fixed-left,
                    table.dataTable tbody tr > .dtfc-fixed-right {
                        background-color: #1f1f1f;
                    }
                    table.dataTable thead tr > .dtfc-fixed-left,
                    table.dataTable thead tr > .dtfc-fixed-right {
                        background-color: #1f1f1f;
                    }
                </style>

                <div class="card card-flush"> 
                    <div class="card-header border-0 pt-5">
                        <h3 class="card-title align-items-start flex-row">
                            <span class="lobby-team-A-name card-label fw-bold fs-3 mb-1"></span>
                            <span class="text-muted fw-semibold fs-7"></span>
                        </h3>
                    </div>

                    <div class="card-body py-3 pb-5">
                        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                            <div class="table-responsive rounded">
                                <table id="scoreboard-A" class="table table-striped gy-4 gs-4 align-middle">
                                    <thead class="w-100 border border-primary border-top-0 border-start-0 border-end-0">
                                        <tr class="fw-bold text-nowrap">
                                            <th class="w-min-150px w-max-200px">Player</th>
                                            <th class="">Rank</th>
                                            <th class="">ELO</th>
                                            <th class="" data-toggle="tooltip" title="Kills">K</th>
                                            <th class="" data-toggle="tooltip" title="Headshots">Hs</th>
                                            <th class="" data-toggle="tooltip" title="Deaths">D</th>
                                            <th class="" data-toggle="tooltip" title="Assists">A</th>
                                            <th class="" data-toggle="tooltip" title="Kill/Death Ratio">KDR</th>
                                            <th class="" data-toggle="tooltip" title="Average Assists per Round">AAR</th>
                                            <th class="" data-toggle="tooltip" title="Average Damage per Round">ADR</th>
                                        </tr>
                                    </thead>
                                    <tbody id="scoreboard-A-body">
                                        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pb-8"></div>

                <div class="card card-flush"> 
                    <div class="card-header border-0 pt-5">
                        <h3 class="card-title align-items-start flex-row">
                            <span class="lobby-team-B-name card-label fw-bold fs-3 mb-1"></span>
                            <span class="text-muted fw-semibold fs-7"></span>
                        </h3>
                    </div>

                    <div class="card-body py-3 pb-5">
                        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                            <div class="table-responsive rounded">
                                <table id="scoreboard-B" class="table table-striped gy-4 gs-4 align-middle">
                                    <thead class="w-100 border border-primary border-top-0 border-start-0 border-end-0">
                                        <tr class="fw-bold text-nowrap">
                                            <th class="w-min-150px w-max-200px">Player</th>
                                            <th class="">Rank</th>
                                            <th class="">ELO</th>
                                            <th class="" data-toggle="tooltip" title="Kills">K</th>
                                            <th class="" data-toggle="tooltip" title="Headshots">Hs</th>
                                            <th class="" data-toggle="tooltip" title="Deaths">D</th>
                                            <th class="" data-toggle="tooltip" title="Assists">A</th>
                                            <th class="" data-toggle="tooltip" title="Kill/Death Ratio">KDR</th>
                                            <th class="" data-toggle="tooltip" title="Average Assists per Round">AAR</th>
                                            <th class="" data-toggle="tooltip" title="Average Damage per Round">ADR</th>
                                        </tr>
                                    </thead>
                                    <tbody id="scoreboard-B-body">
                                        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>                    
                </div>

                
                
            </div>
        </div>

        

    </div>
`;


export default view;